import api from './api';

interface SyncResult {
  synced: number;
  skipped: number;
  total: number;
}

class SyncService {
  /**
   * Sincroniza los últimos N emails del inbox del usuario a Firestore.
   * Se llama UNA VEZ después del login exitoso.
   *
   * @param companyId - ID de la compañía
   * @param count - Número de emails a sincronizar (default: 50, max: 200)
   */
  async initialSync(companyId: string, count: number = 50): Promise<SyncResult | null> {
    const response = await api.post<SyncResult>('/email/sync/initial', {
      companyId,
      count,
    });

    if (response.success && response.data) {
      return response.data;
    }

    if (response.error) {
      throw new Error(response.error.message || 'Error en sync inicial de emails');
    }

    return null;
  }
}

export default new SyncService();
